export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_6-0bdc37b34d652b5e2d432d7e054d6ae4.svg";